import { VARIANT_LANDSCAPE, VARIANT_SQUARE, ELEMENT_IMAGE, } from '../../constants';
export const constants = Object.freeze({
    NAME: 'Image',
    variants: {
        VARIANT_LANDSCAPE,
        VARIANT_SQUARE,
    },
    elements: {
        ELEMENT_IMAGE,
    },
});
export default function getImage() {
    return Object.freeze({
        constants,
    });
}
